import React, {useEffect, useState} from "react";
import {CenterSpinner, useLazyCommand} from "@soap/modules";
import {Button} from "../../ui/button";
import {useFormatTimerString} from "../../../hooks/useFormatTimerString";
import {timingModeKeys} from "../../../z50-domaincomp/constants/timing-mode-keys";

export function SectionLanding({e175, timeLeft, timerControls, e170}) {

    const viewStates = {
        loading: 1,
        loaded: 2
    };

    const [viewState, setViewState] = useState(viewStates.loading);

    const [startSection] = useLazyCommand("C217v1_StartSection");

    useEffect(() => {
        if (e175 && viewState === viewStates.loading) {
            setViewState(viewStates.loaded);

            //e170 always loaded from parent - check if it exists before accessing
            if (e170 && e170.e170_TimingModeKey === timingModeKeys.PerAssessment) {
                if (e175.e175_SectionNumber === 1) {
                    const timeInSeconds = e170.e170_TimeLimit;
                    timerControls.start(timeInSeconds * 1000);
                } else {
                    // Resume timer for sections 2+ in per-assessment mode
                    timerControls.resume();
                }
            }
        }
    }, [e175, e170, viewState, viewStates, timerControls]);

    const {fromSeconds, fromMilliseconds} = useFormatTimerString();

    switch (viewState) {
        case viewStates.loading:
            return <CenterSpinner/>;
        case viewStates.loaded:
            return (
                <div className="space-y-6">
                    {e170 && e170.e170_TimingModeKey === timingModeKeys.PerAssessment && (
                        <div className="text-center">
                            <p className="text-lg text-gray-700">
                                Time Remaining in Assessment: {fromMilliseconds(timeLeft)}
                            </p>
                        </div>
                    )}
                    
                    <div className="text-center space-y-2">
                        <h3 className="text-sm font-medium text-gray-500">
                            Section {e175.e175_SectionNumber} of {e175.e175_SectionCount}
                        </h3>
                        <h2 className="text-2xl font-semibold text-gray-900">
                            {e175.e175_SectionTitle}
                        </h2>
                    </div>

                    <div className="text-center">
                        <p className="text-lg text-gray-700">
                            This section contains {e175.e175_QuestionCount} {e175.e175_QuestionCount === 1 ? "question" : "questions"}.
                        </p>
                    </div>

                    {e175.e175_AssessmentTimingModeKey === timingModeKeys.PerSection && (
                        <div className="text-center">
                            <p className="text-lg text-gray-700">
                                This section is timed. You will have up to {fromSeconds(e175.e175_TimeInSeconds)} to complete it.
                            </p>
                        </div>
                    )}

                    {e175.e175_AssessmentTimingModeKey === timingModeKeys.PerQuestion && (
                        <div className="text-center">
                            <p className="text-lg text-gray-700">
                                The questions in this section are individually timed.
                            </p>
                        </div>
                    )}

                    <div className="flex justify-end pt-4">
                        <Button 
                            onClick={() => {
                                startSection({
                                    C217_SectionId: e175.e175_SectionId,
                                    C217_AssessmentResultId: e175.e175_AssessmentResultId
                                });
                            }}
                            className="px-6 py-2"
                        >
                            Continue
                        </Button>
                    </div>
                </div>
            );
    }

}

